export function DesktopCta({ tone = 'dark' }: { tone?: 'light' | 'dark' }) {
  const isDark = tone === 'dark'

  return (
    <a
      href="tel:+33620111014"
      title="Appelez-nous"
      aria-label="Appeler le 06 20 11 10 14"
      className={`group hidden desktop:inline-flex items-center gap-3 rounded-[3px] border px-5 py-3 transition-colors duration-300 ${
        isDark
          ? 'border-chalk/25 text-chalk hover:border-signal hover:bg-signal hover:text-white'
          : 'border-ink/20 text-ink hover:border-signal hover:bg-signal hover:text-white'
      }`}
    >
      {/* Pastille de disponibilité : le seul point de signal permanent. */}
      <span
        aria-hidden="true"
        className="size-1.5 rounded-full bg-signal transition-colors group-hover:bg-white"
      />
      <span
        data-figure
        className="font-mono text-sm font-medium tracking-[0.08em]"
      >
        06 20 11 10 14
      </span>
    </a>
  )
}
